// api =>
import backEnd from "../../services/api";

export const getInsightsList = async () => {
    try {
        const response = await backEnd.get("landing/insights/");
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}

export const getInsightsStoryList = async (insightId) => {
    try {
        const response = await backEnd.get(`landing/insights/${ insightId }/stories/`);
        return response.data;
    } catch (errorKey) {
        console.log(errorKey);
        return [];
    }
}
